import * as Popper from "@popperjs/core"
import * as bootstrap from 'bootstrap';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))


function setScrollBodyClasses() {
    const st = window.scrollY || document.documentElement.scrollTop;
    st === 0
        ? document.body.classList.remove('scroll-offset')
        : document.body.classList.add('scroll-offset')

}

window.addEventListener("scroll", function(){
    setScrollBodyClasses();
}, false);

document.addEventListener('freeform-ready', (event) => {
    // scrolling offset in pixels from the top of the form.
    // defaults to 0
    event.options.scrollOffset = -180;
});


document.addEventListener('freeform-ajax-success', (event) => {
    const form = event.form;

    const tooltipTriggerList = form.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

});
